// 🖥️ 원장실 PC 프로그램 「덴클 원장 호출」 내려받기 (대표 10-13 "웹에서 원장호출쪽에 PC 프로그램 다운 받을 수 있도록")
//   설치 파일 = Storage agents/ (덴클 에이전트와 같은 공개 경로, 업로드는 관리자만 — storage.rules agents/{fileName}).
//   버전을 올리면 DCALL_VERSION 과 Storage 파일을 같이 바꾼다. 소스 dentcluster-call/ · 계획 docs/계획_원장실PC앱_2026-10-13.md
//   윈도우 = 관리자 승인 없이 설치(per-user), 코드서명 없음 → SmartScreen 안내. 맥 = Apple 칩만·공증 없음 → 첫 실행 안내(docs/안내_덴클원장호출_맥설치_2026-10-13.md 요약).
import React, { useState } from 'react';

const DCALL_VERSION = '0.1.0';
const STORAGE_BASE = 'https://firebasestorage.googleapis.com/v0/b/dental-lab-system.firebasestorage.app/o';
const fileUrl = (name) => `${STORAGE_BASE}/${encodeURIComponent(`agents/${name}`)}?alt=media`;
const URLS = {
    windows: fileUrl(`DentClusterCall-Setup-${DCALL_VERSION}.exe`),
    mac: fileUrl(`DentClusterCall-${DCALL_VERSION}-arm64.dmg`),
};

export default function DoctorCallPcDownload() {
    const [help, setHelp] = useState(null);   // 'windows' | 'mac' | null
    return (
        <div style={S.box}>
            <div style={S.title}>{'원장실 PC 프로그램'}</div>
            <div style={S.desc}>
                {'원장실 컴퓨터에 설치하면 호출이 올 때 화면 맨 앞에 창이 뜨고 소리로 알려 줍니다. 치과 덴클 계정으로 로그인하고, 컴퓨터를 켜면 저절로 시작합니다.'}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                <a href={URLS.windows} style={S.btnPri} onClick={() => setHelp('windows')}>{'윈도우용 내려받기 (85MB)'}</a>
                <a href={URLS.mac} style={S.btn} onClick={() => setHelp('mac')}>{'맥용 내려받기 (117MB)'}</a>
            </div>
            <div style={S.sub}>{`버전 ${DCALL_VERSION} · 원장실 PC 1대에만 설치하면 됩니다`}</div>

            {help === 'windows' && (
                <ol style={S.steps}>
                    <li>{'받은 파일을 두 번 누릅니다. 관리자 승인 없이 바로 설치되고 프로그램이 켜집니다.'}</li>
                    <li>{'파란 「Windows의 PC 보호」 창이 뜨면 [추가 정보] → [실행]을 누릅니다.'}</li>
                    <li>{'치과 덴클 계정으로 로그인하고, 데스크에서 시험 호출을 한 번 보내 확인합니다.'}</li>
                </ol>
            )}
            {help === 'mac' && (
                <ol style={S.steps}>
                    <li>{'Apple 칩(M1~M4) 맥만 됩니다. 「 > 이 Mac에 관하여」에서 확인하세요. 인텔 맥은 아직 지원하지 않습니다.'}</li>
                    <li>{'받은 파일을 열고 DentClusterCall을 Applications(응용 프로그램) 폴더로 끌어다 놓습니다.'}</li>
                    <li>{'처음 열 때 막히면 「시스템 설정 > 개인정보 보호 및 보안」에서 [그래도 열기]를 누릅니다.'}</li>
                    <li>{'"손상되었기 때문에 열 수 없습니다"가 뜨면 덴탈클러스터(010-7306-2804)로 연락 주세요. 설치를 도와드립니다.'}</li>
                </ol>
            )}
        </div>
    );
}

const S = {
    box: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: '16px 18px', marginBottom: 14 },
    title: { fontSize: 14.5, fontWeight: 700, color: '#0f172a', marginBottom: 8 },
    desc: { fontSize: 13.5, color: '#334155', lineHeight: 1.6 },
    sub: { fontSize: 12, color: '#94a3b8', marginTop: 8 },
    steps: { fontSize: 13, color: '#334155', lineHeight: 1.7, margin: '12px 0 0', paddingLeft: 20 },
    btnPri: { border: '1px solid #0f6b5c', background: '#0f6b5c', color: '#fff', borderRadius: 8, padding: '8px 16px', fontSize: 14, fontWeight: 700, textDecoration: 'none' },
    btn: { border: '1px solid #cbd5e1', background: '#fff', color: '#0f172a', borderRadius: 8, padding: '8px 14px', fontSize: 13.5, textDecoration: 'none' },
};
